module.exports = __webpack_public_path__ + "img/ua.cf0c99b7.png";